import React from 'react'
import GenericToggleButton, { type ToggleOption } from '../../../../components/GenericToggleButton'
import dayjs from 'dayjs'
import HistoryARTableComponent from './HistoryARTableComponent'
// import { Button } from '../../../../components/Button'
// import FilterIcon from '../../../../assets/filterIcon.png'
// import SearchBox from '../../../../components/SearchBox'
// import KpiHistoryFilter from './KpiHistoryFilter'
import { type ConnectedProps, connect } from 'react-redux'
import { type RootState } from '../../../../store'
import { fetchKpiHistoryAR, fetchKpiHistoryADS, fetchDonutKpiHistoryTable, fetchKpiHistoryAS } from '../../redux/actionCreators'
import { doesKpiHaveDonutChart, isSingleBarKpi, type KpiKeyDonut, type KpiKey } from '../../redux/changeKpiType'
import { useSelector } from 'react-redux'
import { getDetailKeyword, getDonutType, getToggleOptions } from './kpiUtils'
import HistoryADSTableComponent from './HistoryADSTableComponent'
import HistoryDonutKpiTableComponent from './HistoryDonutKpiTableComponent'
import { type DonutKpiState } from '../../types'
import HistoryASTableComponent from './HistoryASTableComponent'

interface ParentProps {
  selectedBar: ToggleOption
  selectedDate: dayjs.Dayjs
  selectedDonut: number
  setSelectedBar: React.Dispatch<React.SetStateAction<ToggleOption>>
}

type Order = 'asc' | 'desc'

interface Sort {
  order: Order
  orderBy: string
}

const HistoryTable = (props: AllProps): JSX.Element => {
  const rowsPerPage = 10
  const selectedKpi = useSelector((state: RootState) => state.kpiType)
  const [page, setPage] = React.useState(1)
  const [sort, setSort] = React.useState<Sort>({ order: 'asc', orderBy: 'serialNumber' })
  const [detailKeyword, detailService] = getDetailKeyword(selectedKpi, props.selectedBar.value)

  const fetchAssets = (): void => {
    if (doesKpiHaveDonutChart(selectedKpi)) {
      props.fetchDonutKpiHistoryTable(detailKeyword, dayjs(props.selectedDate).format('YYYY-MM-DD'), getDonutType(selectedKpi as KpiKeyDonut, props.selectedDonut, props.historyDonutState), page - 1, rowsPerPage, detailService)
    } else {
      if (detailService === 'assetrest') {
        props.fetchKpiHistoryAR(detailKeyword, dayjs(props.selectedDate).format('YYYY-MM-DD'), page - 1, rowsPerPage, detailService)
      } else if (detailService === 'alarm-service') {
        props.fetchKpiHistoryAS(detailKeyword, dayjs(props.selectedDate).format('YYYY-MM-DD'), page - 1, rowsPerPage, detailService)
      } else {
        props.fetchKpiHistoryADS(detailKeyword, dayjs(props.selectedDate).format('YYYY-MM-DD'), page - 1, rowsPerPage, detailService)
      }
    }
  }

  React.useEffect(() => {
    fetchAssets()
  }, [props.selectedDate, props.selectedBar, page, props.selectedDonut])

  const getHistoryTable = (): JSX.Element => {
    if (doesKpiHaveDonutChart(selectedKpi)) {
      return <HistoryDonutKpiTableComponent selectedDonut={props.selectedDonut} rowPerPage={rowsPerPage} page={page} setPage={setPage} sort={sort} setSort={setSort} selectedBar={props.selectedBar} selectedDate={props.selectedDate} />
    } else {
      if (detailService === 'assetrest') {
        return <HistoryARTableComponent rowPerPage={rowsPerPage} page={page} setPage={setPage} sort={sort} setSort={setSort} selectedBar={props.selectedBar} selectedDate={props.selectedDate} />
      } else if (detailService === 'alarms-service') {
        return <HistoryASTableComponent rowPerPage={rowsPerPage} page={page} setPage={setPage} sort={sort} setSort={setSort} selectedBar={props.selectedBar} selectedDate={props.selectedDate} />
      } else {
        return <HistoryADSTableComponent rowPerPage={rowsPerPage} page={page} setPage={setPage} sort={sort} setSort={setSort} selectedBar={props.selectedBar} selectedDate={props.selectedDate} />
      }
    }
  }

  return (
    <>
      <div style={{ display: 'flex', padding: '10px', borderBottom: '2px solid #202020' }}>
        {
          (!isSingleBarKpi(selectedKpi) && !doesKpiHaveDonutChart(selectedKpi)) && <span style={{ paddingRight: '1em' }}>
          <GenericToggleButton options={getToggleOptions(selectedKpi)} selected={props.selectedBar} onChange={(option) => { props.setSelectedBar(option) }} />
        </span>
        }
      </div>
      <div>
        {getHistoryTable()}
      </div>
    </>
  )
}

interface DispatchToProps {
  fetchKpiHistoryAR: (
    kpiType: string,
    inputDateRead: string,
    page: number,
    size: number, service: string) => void
  fetchKpiHistoryADS: (
    kpiType: string,
    inputDateRead: string,
    page: number,
    size: number, service: string) => void
  fetchDonutKpiHistoryTable: (
    kpiType: string,
    inputDateRead: string,
    donutType: string,
    page: number,
    size: number, service: string) => void
  fetchKpiHistoryAS: (
    kpiType: string,
    inputDateRead: string,
    page: number,
    size: number, service: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  fetchKpiHistoryAR: (
    kpiType: string,
    inputDateRead: string,
    page: number,
    size: number, service: string) => dispatch(fetchKpiHistoryAR(kpiType, inputDateRead, page, size, service)),
  fetchKpiHistoryADS: (
    kpiType: string,
    inputDateRead: string,
    page: number,
    size: number, service: string) => dispatch(fetchKpiHistoryADS(kpiType, inputDateRead, page, size, service)),
  fetchDonutKpiHistoryTable: (
    kpiType: string,
    inputDateRead: string,
    donutType: string,
    page: number,
    size: number, service: string) => dispatch(fetchDonutKpiHistoryTable(kpiType, inputDateRead, donutType, page, size, service)),
  fetchKpiHistoryAS: (
    kpiType: string,
    inputDateRead: string,
    page: number,
    size: number, service: string) => dispatch(fetchKpiHistoryAS(kpiType, inputDateRead, page, size, service))
})

interface StateToProps {
  kpiType: KpiKey
  historyDonutState: DonutKpiState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  kpiType: state.kpiType,
  historyDonutState: state.historyDonutState
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>
type AllProps = ParentProps & PropsFromRedux

export default connector(HistoryTable)
